import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Purchase from "../pages/purchase/page";
import Profile from "../pages/profile/page";
import EditProfile from "../pages/edit-profile/page";
import Announcements from "../pages/announcements/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import ForgotPassword from "../pages/forgot-password/page";
import AnnouncementDetail from "../pages/announcements/detail/page";
import BuyerWarehouse from "../pages/buyer-warehouse/page";
import SellerWarehouse from "../pages/seller-warehouse/page";
import VoucherDetails from "../pages/voucher-details/page";
import CouponDetails from "../pages/coupon-details/page";
import BonusDetails from "../pages/bonus-details/page";
import CommissionDetails from "../pages/commission-details/page";
import InvitePage from "../pages/invite/page";
import TeamPage from "../pages/team/page";
import AddressPage from "../pages/address/page";
import VerifyPage from "../pages/verify/page";
import VoucherMallPage from "../pages/voucher-mall/page";
import ExchangeDetailPage from "../pages/exchange-detail/page";
import AgreementsPage from "../pages/agreements/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/purchase",
    element: <Purchase />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/edit-profile",
    element: <EditProfile />,
  },
  {
    path: "/announcements",
    element: <Announcements />,
  },
  {
    path: "/announcements/:id",
    element: <AnnouncementDetail />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/buyer-warehouse",
    element: <BuyerWarehouse />,
  },
  {
    path: "/seller-warehouse",
    element: <SellerWarehouse />,
  },
  {
    path: "/voucher-details",
    element: <VoucherDetails />,
  },
  {
    path: "/coupon-details",
    element: <CouponDetails />,
  },
  {
    path: "/bonus-details",
    element: <BonusDetails />,
  },
  {
    path: "/commission-details",
    element: <CommissionDetails />,
  },
  {
    path: "/invite",
    element: <InvitePage />,
  },
  {
    path: "/team",
    element: <TeamPage />,
  },
  {
    path: "/address",
    element: <AddressPage />,
  },
  {
    path: "/verify",
    element: <VerifyPage />,
  },
  {
    path: "/voucher-mall",
    element: <VoucherMallPage />,
  },
  {
    path: "/exchange-detail/:id",
    element: <ExchangeDetailPage />,
  },
  {
    path: "/agreements",
    element: <AgreementsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;